// Simple authentication client - more reliable than Better Auth
const API_BASE_URL = process.env.REACT_APP_SERVER_URL || 'http://localhost:8080';

class SimpleAuthClient {
  constructor() {
    this.user = null;
    this.listeners = new Set();
    this.isSigningOut = false;
  }

  // Add listener for authentication state changes
  addListener(listener) {
    this.listeners.add(listener);
  }

  // Remove listener
  removeListener(listener) {
    this.listeners.delete(listener);
  }

  // Notify all listeners of state change
  notifyListeners() {
    this.listeners.forEach(listener => listener(this.user));
  }

  // Get current session
  async getSession() {
    // Check server for JWT token in cookie
    try {
      const response = await fetch(`${API_BASE_URL}/api/auth/session-with-preferences`, {
        credentials: 'include',
      });

      if (response.ok) {
        const sessionData = await response.json();
        if (sessionData.user) {
          this.user = sessionData.user;
        } else {
          this.user = null;
        }
        this.notifyListeners();
        return { user: this.user, preferences: sessionData.preferences };
      } else {
        this.user = null;
        this.notifyListeners();
        return null;
      }
    } catch (error) {
      this.user = null;
      this.notifyListeners();
      return null;
    }
  }

  // Sign in with Google
  async signInWithGoogle(callbackURL = window.location.origin) {
    try {
      // Redirect to Google OAuth
      window.location.href = `${API_BASE_URL}/api/auth/signin/google?callbackUrl=${encodeURIComponent(callbackURL)}`;
    } catch (error) {
      throw error;
    }
  }

  // Sign out
  async signOut() {
    // Set flag to prevent UI updates during sign out
    this.isSigningOut = true;

    try {
      await fetch(`${API_BASE_URL}/api/auth/signout`, {
        method: 'POST',
        credentials: 'include',
      });
    } catch (error) {
      // Sign out error handled silently
    }

    // Immediately reload page to prevent UI flicker
    // Don't notify listeners or clear state - just redirect
    window.location.href = '/';
  }
}

export const simpleAuth = new SimpleAuthClient();